import { SaleTaxComponent } from './saletax.component';
export var saleTaxRoutes = [
    {
        path: 'saletax',
        component: SaleTaxComponent
    },
];
var SaleTaxRoutingModule = (function () {
    function SaleTaxRoutingModule() {
    }
    return SaleTaxRoutingModule;
}());
export { SaleTaxRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax-routing.module.ts.pre-build-optimizer.js